import * as React from 'react';

import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';

import AppView from '~common/components/app-view/index';
import ErrorView from '~common/components/error-view';
import * as request from 'superagent';

import { Theme } from '@mui/styles';
import LoadingView from '~common/components/loading-view';
import QueryList from '~common/components/query-fulfillment/query-list';
import portalUserContext from '~common/lib/portal-user-context';
import { saveAs } from 'file-saver';


const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden'
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
}

type State = {
  status: 'loading' | 'ready' | 'error';
  error?: any;
};

class UserLoginReportView extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: 'loading'
    };
  }

 componentDidMount() {
    const st = this.state;
    st.status = 'ready';
    this.setState(st);

  }

  handleCriteriaFormSelection = (formDef: any): any => {

  };


  handleActionsForItemRow = (row: any) => {
    var actions = Array<any>();
    return actions;
  };

  handleRowClick = (row: any) => {
  };

  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {status, error} = this.state;

    const criteriaSelector = {
      module: 'users',
      formType: 'portalUserLoginReportCriteria'
    };

    const resultsSelector = {
        module: 'users',
        formType: 'portalUserLoginReportResults'
      }

    criteriaSelector['userType'] = portalUserContext.userType;
    if (criteriaSelector['userType'] == 'Portal Admin') {
      criteriaSelector['userType'] = 'Internal';
    }

    switch (status) {
      case 'loading':
        return (
          <AppView>
            <div className={classes.container}>
              <LoadingView classes={{}} />
            </div>
          </AppView>
        );
      case 'error':
        return (
          <AppView>
            <div className={classes.container}>
              <ErrorView error={error} classes={} />
            </div>
          </AppView>
        );
      default:
        return (
          <AppView>
            <div className={classes.container}>
              <QueryList
                criteriaFormSelector={criteriaSelector}
                resultsFormSelector={resultsSelector}
                queryUrl="/api/users/logins/report"
                autoQuery={true}
                excludeFromClear={}
                onCriteriaFormSelection={this.handleCriteriaFormSelection}
                supressSectionStatusIcon
                actionsForItemRow={this.handleActionsForItemRow}
                alwaysExecuteOnSubmit={true}
                forceExecuteOnLoad={false}
                customRenderers={}
                noResultsText="No Results Found"
                reserveRowActionSpace={true}
                pruneCriteriaForm={true}
                submitButtonText="Search"
              />
            </div>
          </AppView>
        );
    }
  }
}

export default withStyles(styles)(UserLoginReportView);
